import React from 'react'
import styled from 'styled-components'



const Section = styled.section`
min-height:100vh;
width:80vw;
margin:0 auto ;

display:flex; 
justify-content:center;
align-items:center;

position:relative;
`

const Container = styled.div`

min-height:100vh;
display:flex;
flex-direction:column;
justify-content:space-evenly;
align-items:center;

`
const BannerComponent = styled.h1`
font-size:${props=>props.theme.fontxxxl};
font-family:"Kaushan Script";
color:${props => props.theme.text};
white-space:nowrap;
text-transformation:uppercse;
line-height:1;

span{
    display:block;
    background-color:${props=>props.theme.body};
    padding:1rem 2rem;
}
`




const Banner = () => {
  return (
    
    <Section>
        <Container id='up'>
            <BannerComponent>
                <span data-Scroll data-scroll-speed="8" data-scroll-target="#up" data-scroll-direction="horizontal">Fashion is the armour </span>
            </BannerComponent>
            <BannerComponent>
                <span data-Scroll data-scroll-speed="-6" data-scroll-target="#up" data-scroll-direction="horizontal">to survive the reality of everyday life.</span>
            </BannerComponent>
            <BannerComponent>
                <span data-Scroll data-scroll-speed="6" data-scroll-target="#up" data-scroll-direction="horizontal">One is never over-dressed or </span>
            </BannerComponent>
            <BannerComponent>
                <span data-Scroll data-scroll-speed="-4" data-scroll-target="#up" data-scroll-direction="horizontal">under-dressed </span>
            </BannerComponent>
            <BannerComponent>
                <span data-Scroll data-scroll-speed="6" data-scroll-target="#up" data-scroll-direction="horizontal">with a Little Black Dress.</span>
            </BannerComponent>
        </Container>
    </Section>
    
  )
}

export default Banner
